module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Партнерская программа","text":"Получайте от 20 до 40% за приглашенных пользователей. <br />\\nПросто поделитесь этой ссылкой, и получайте от 20 до 40% от всех покупок приглашенных пользователей\\n","rules":"Размер вознаграждения зависит от общего количества покупок приглашенных пользователей\\nи каждые 25000р увеличивается на 2%\\n"}}')
  delete Component.options._Ctor
}
